// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// const GrantReport = () => {
//   const [grants, setGrants] = useState([]);
//   const [selectedGrant, setSelectedGrant] = useState('');
//   const [reportData, setReportData] = useState([]);

//   useEffect(() => {
//     fetchGrants();
//   }, []);

//   // Fetch the list of grants for dropdown selection
//   const fetchGrants = async () => {
//     try {
//       const response = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/grants`);
//       setGrants(response.data);
//     } catch (error) {
//       console.error('Error fetching grants:', error);
//     }
//   };

//   // Fetch the details of the selected grant
//   const fetchGrantDetails = async (grantNumber) => {
//     try {
//       const response = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/reports/${grantNumber}`);
//       setReportData(response.data);
//     } catch (error) {
//       console.error('Error fetching grant details:', error);
//     }
//   };

//   // Handle dropdown selection change
//   const handleGrantChange = async (event) => {
//     const value = event.target.value;
//     setSelectedGrant(value);
//     if (value) {
//       fetchGrantDetails(value);
//     }
//   };

//   return (
//     <div className="grant-report">
//       <h1>Grant Report</h1>
//       <select value={selectedGrant} onChange={handleGrantChange}>
//         <option value="">Select a grant</option>
//         {grants.map((grant) => (
//           <option key={grant['Grant/Contract Number']} value={grant['Grant/Contract Number']}>
//             {grant['Grant/Contract Number']} - {grant['Project Title']}
//           </option>
//         ))}
//       </select>
//       <table>
//         <thead>
//           <tr>
//             <th>Description</th>
//             <th>Current Budget</th>
//             <th>Expended to Date</th>
//             <th>Budget Balance Available</th>
//           </tr>
//         </thead>
//         <tbody>
//           {reportData.map((row, index) => (
//             <tr key={index}>
//               <td>{row.Description}</td>
//               <td>${row['Current Budget'].toFixed(2)}</td>
//               <td>${row['Expended to Date'].toFixed(2)}</td>
//               <td>${row['Budget Balance Available'].toFixed(2)}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default GrantReport;

import React, { useState, useEffect } from "react";
import axios from "axios";
import "./GrantReport.css";
import PersonnelTimeAllocationCalculator from "./PersonnelTimeAllocationCalculator";

const GrantReport = () => {
    const [grants, setGrants] = useState([]);
    const [selectedGrant, setSelectedGrant] = useState("");
    const [reportData, setReportData] = useState([]);
    const [personnelExpanded, setPersonnelExpanded] = useState(true);
    const [otherExpanded, setOtherExpanded] = useState(false);
    const [indirectCostData, setIndirectCostData] = useState({
        indirectBase: 0,
        indirectFederalShare: 0,
        indirectRate: 0,
    });

    useEffect(() => {
        fetchGrants();
    }, []);

    const fetchGrants = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_API_URL}/grants`
            );
            setGrants(response.data);
        } catch (error) {
            console.error("Error fetching grants:", error);
        }
    };

    const fetchGrantDetails = async (grantNumber) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_API_URL}/reports/${grantNumber}`
            );
            const data = response.data.reportRows || response.data;

            console.log("Fetched grant details:", data);

            // Add subtotals and spacing rows
            const updatedData = addSubtotalsAndSpacing(data);

            calculateIndirectCostData(updatedData);

            setReportData(updatedData);
        } catch (error) {
            console.error("Error fetching grant details:", error);
        }
    };

    const toggleOtherExpanded = () => {
        setOtherExpanded(!otherExpanded);
    };

    // Update the calculateIndirectCostData function

    const calculateIndirectCostData = (data) => {
        // Find relevant categories
        const totalDirectCosts = data.find(
            (row) => row.Description === "Total Direct Costs"
        );
        const fee = data.find((row) => row.Description === "Fee");
        const equipment = data.find((row) => row.Description === "Equipment");
        const overhead = data.find(
            (row) => row.Description === "Overhead/Facilities & Administrative"
        );
        const other = data.find((row) => row.Description === "Other");

        // Default values if not found
        const totalDirectCostsExpended =
            totalDirectCosts?.["Expended to Date"] || 0;
        const feeExpended = fee?.["Expended to Date"] || 0;
        const equipmentExpended = equipment?.["Expended to Date"] || 0;
        const overheadExpended = overhead?.["Expended to Date"] || 0;

        // Calculate metrics - include Other in direct costs, not in overhead calculation
        const indirectBase =
            totalDirectCostsExpended - feeExpended - equipmentExpended;
        const indirectFederalShare = overheadExpended;
        const indirectRate =
            indirectBase > 0 ? (indirectFederalShare / indirectBase) * 100 : 0;

        setIndirectCostData({
            indirectBase,
            indirectFederalShare,
            indirectRate,
        });
    };

    const addSubtotalsAndSpacing = (data) => {
        const updatedData = [...data];

        // Find index of 'Personnel Costs'
        const personnelCostsIndex = updatedData.findIndex(
            (row) => row.Description === "Personnel Costs"
        );

        // Add subtotal for Personnel Costs
        const personnelCostsSubtotal = {
            Description: "Sub-total",
            "Current Budget":
                updatedData[personnelCostsIndex]["Current Budget"],
            "Expended to Date":
                updatedData[personnelCostsIndex]["Expended to Date"],
            "Budget Balance Available":
                updatedData[personnelCostsIndex]["Budget Balance Available"],
        };

        const personnelDetailIndices = [];
        for (let i = personnelCostsIndex + 1; i < updatedData.length; i++) {
            if (updatedData[i].isPersonnelDetail) {
                personnelDetailIndices.push(i);
            } else {
                break;
            }
        }

        // Find index of 'Fee'
        const feeIndex = updatedData.findIndex(
            (row) => row.Description === "Fee"
        );

        // Find index of 'Other'
        const otherIndex = updatedData.findIndex(
            (row) => row.Description === "Other"
        );

        // Find the last 'Other Detail' row (if any)
        let lastOtherDetailIndex = otherIndex;
        if (otherIndex !== -1) {
            for (let i = otherIndex + 1; i < updatedData.length; i++) {
                if (updatedData[i].isOtherDetail) {
                    lastOtherDetailIndex = i;
                } else {
                    break;
                }
            }
        }

        // Calculate subtotal for all categories between Personnel and Other
        // (Materials & Supplies, Travel, Equipment, Fee, and any custom categories)
        const firstNonPersonnelIndex = personnelDetailIndices.length > 0
            ? personnelDetailIndices[personnelDetailIndices.length - 1] + 1
            : personnelCostsIndex + 1;
        // Slice from first non-personnel category up to (but not including) Other
        const endSliceIndex = otherIndex !== -1 ? otherIndex : feeIndex + 1;
        const middleCategoriesSubtotal = updatedData
            .slice(firstNonPersonnelIndex, endSliceIndex)
            .filter(row => row.Description && !row.isPersonnelDetail)
            .reduce(
                (acc, row) => ({
                    Description: "Sub-total",
                    "Current Budget":
                        acc["Current Budget"] + (row["Current Budget"] || 0),
                    "Expended to Date":
                        acc["Expended to Date"] + (row["Expended to Date"] || 0),
                    "Budget Balance Available":
                        acc["Budget Balance Available"] +
                        (row["Budget Balance Available"] || 0),
                }),
                {
                    "Current Budget": 0,
                    "Expended to Date": 0,
                    "Budget Balance Available": 0,
                }
            );

        // Add Other costs to direct costs
        const otherCosts = otherIndex !== -1 ? {
            "Current Budget": updatedData[otherIndex]["Current Budget"] || 0,
            "Expended to Date": updatedData[otherIndex]["Expended to Date"] || 0,
            "Budget Balance Available": updatedData[otherIndex]["Budget Balance Available"] || 0,
        } : {
            "Current Budget": 0,
            "Expended to Date": 0,
            "Budget Balance Available": 0,
        };

        // Calculate Total Direct Costs (include Other in the direct costs)
        const totalDirectCosts = {
            Description: "Total Direct Costs",
            "Current Budget":
                personnelCostsSubtotal["Current Budget"] +
                middleCategoriesSubtotal["Current Budget"] +
                otherCosts["Current Budget"],
            "Expended to Date":
                personnelCostsSubtotal["Expended to Date"] +
                middleCategoriesSubtotal["Expended to Date"] +
                otherCosts["Expended to Date"],
            "Budget Balance Available":
                personnelCostsSubtotal["Budget Balance Available"] +
                middleCategoriesSubtotal["Budget Balance Available"] +
                otherCosts["Budget Balance Available"],
        };

        // Find the right position to insert Total Direct Costs
        // Insert it after the last Other detail if any exist, otherwise after Other itself
        const insertPosition = lastOtherDetailIndex + 1;

        // Insert Total Direct Costs row with spacing
        updatedData.splice(
            insertPosition,
            0,
            { Description: "" },
            totalDirectCosts,
            { Description: "" }
        );

        // Find index of 'Overhead/Facilities & Administrative' (after insertion)
        const overheadIndex = updatedData.findIndex(
            (row) => row.Description === "Overhead/Facilities & Administrative"
        );

        // Calculate Sub-total of Direct and Indirect Costs
        const directAndIndirectSubtotal = {
            Description: "Sub-total of Direct and Indirect Costs",
            "Current Budget":
                totalDirectCosts["Current Budget"] +
                updatedData[overheadIndex]["Current Budget"],
            "Expended to Date":
                totalDirectCosts["Expended to Date"] +
                updatedData[overheadIndex]["Expended to Date"],
            "Budget Balance Available":
                totalDirectCosts["Budget Balance Available"] +
                updatedData[overheadIndex]["Budget Balance Available"],
        };
        
        updatedData.splice(overheadIndex + 1, 0, directAndIndirectSubtotal, {
            Description: "",
        });

        // Remove Sub-total under Other if it exists
        for (let i = 0; i < updatedData.length; i++) {
            if (updatedData[i].Description === "Other" && 
                i + 1 < updatedData.length && 
                updatedData[i + 1].Description === "Sub-total") {
                updatedData.splice(i + 1, 1);
                break;
            }
        }

        return updatedData;
    };

    const handleGrantChange = async (event) => {
        const value = event.target.value;
        setSelectedGrant(value);
        console.log("Selected grant:", value);
        if (value) {
            fetchGrantDetails(value);
        } else {
            setReportData([]);
            setIndirectCostData({
                indirectBase: 0,
                indirectFederalShare: 0,
                indirectRate: 0,
            });
        }
    };

    const togglePersonnelExpanded = () => {
        setPersonnelExpanded(!personnelExpanded);
    };

    const downloadCSV = () => {
        if (reportData.length === 0) return;

        const headers = [
            "Description",
            "Current Budget",
            "Expended to Date",
            "Budget Balance Available",
        ];
        const csvContent = [
            headers.join(","),
            ...reportData.map((row) =>
                headers
                    .map((header) =>
                        typeof row[header] === "number"
                            ? row[header].toFixed(2)
                            : row[header]
                    )
                    .join(",")
            ),
        ].join("\n");

        csvContent.push(""); // Empty row for spacing
        csvContent.push(`Indirect Cost Calculations`);
        csvContent.push(
            `Indirect Base,$${indirectCostData.indirectBase.toFixed(2)}`
        );
        csvContent.push(
            `Indirect Federal Share,$${indirectCostData.indirectFederalShare.toFixed(
                2
            )}`
        );
        csvContent.push(
            `Indirect Rate,${indirectCostData.indirectRate.toFixed(2)}%`
        );

        const finalCsvContent = csvContent.join("\n");

        const blob = new Blob([finalCsvContent], {
            type: "text/csv;charset=utf-8;",
        });
        const link = document.createElement("a");
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", "grant_report.csv");
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    const renderReportRow = (row, index) => {
        // Hide personnel details if collapsed
        if (row.isPersonnelDetail && !personnelExpanded) {
            return null;
        }

        if (row.isOtherDetail && !otherExpanded) {
            return null;
        }

        // Determine if this row is a total or subtotal based on description
        const isTotalOrSubtotal = 
            row.Description === "Sub-total" || 
            row.Description === "Total Direct Costs" ||
            row.Description === "Sub-total of Direct and Indirect Costs" ||
            row.Description === "Total";
        
        return (
            <tr
                key={index}
                className={`
                    ${row.isPersonnelDetail ? "personnel-detail" : ""}
                    ${row.isOtherDetail ? "other-detail" : ""}
                    ${isTotalOrSubtotal ? "" : ""}
                `}
            >
                <td>
                    {row.Description === "Personnel Costs" ? (
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <span
                                onClick={togglePersonnelExpanded}
                                className="expand-toggle"
                            >
                                {personnelExpanded ? "▼" : "►"}
                            </span>
                            {row.Description}
                        </div>
                    ) : row.Description === "Other" ? (
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <span
                                onClick={toggleOtherExpanded}
                                className="expand-toggle"
                            >
                                {otherExpanded ? "▼" : "►"}
                            </span>
                            {row.Description}
                        </div>
                    ) : (
                        <>
                            {isTotalOrSubtotal ? <strong>{row.Description}</strong> : row.Description}
                        </>
                    )}
                </td>
                <td>
                    {row.Description && row["Current Budget"] !== null && (
                        isTotalOrSubtotal ? (
                            <strong>{`$${typeof row["Current Budget"] === "number" ? row["Current Budget"].toFixed(2) : row["Current Budget"]}`}</strong>
                        ) : (
                            `$${typeof row["Current Budget"] === "number" ? row["Current Budget"].toFixed(2) : row["Current Budget"]}`
                        )
                    )}
                </td>
                <td>
                    {row.Description && !isTotalOrSubtotal
                        ? `$${
                            typeof row["Expended to Date"] === "number"
                                ? row["Expended to Date"].toFixed(2)
                                : row["Expended to Date"]
                        }`
                        : ""}
                    {isTotalOrSubtotal && row["Expended to Date"] !== null && (
                        <strong>{`$${typeof row["Expended to Date"] === "number" ? row["Expended to Date"].toFixed(2) : row["Expended to Date"]}`}</strong>
                    )}
                </td>
                <td>
                    {row.Description && !isTotalOrSubtotal && row["Budget Balance Available"] !== null
                        ? `$${
                            typeof row["Budget Balance Available"] === "number"
                                ? row["Budget Balance Available"].toFixed(2)
                                : row["Budget Balance Available"]
                        }`
                        : ""}
                    {isTotalOrSubtotal && row["Budget Balance Available"] !== null && (
                        <strong>{`$${typeof row["Budget Balance Available"] === "number" ? row["Budget Balance Available"].toFixed(2) : row["Budget Balance Available"]}`}</strong>
                    )}
                </td>
            </tr>
        );
    };

    return (
        <div className="grant-report">
            <h1>Grant Report</h1>
            <div className="grant-selection">
                <select value={selectedGrant} onChange={handleGrantChange}>
                    <option value="">Select a grant</option>
                    {grants.map((grant) => (
                        <option
                            key={grant["Grant/Contract Number"]}
                            value={grant["Grant/Contract Number"]}
                        >
                            {grant["Grant Nickname"] ? `${grant["Grant Nickname"]} - ` : ''}{grant["Grant/Contract Number"]} -{" "}
                            {grant["Project Title"]}
                        </option>
                    ))}
                </select>
                <button
                    onClick={downloadCSV}
                    disabled={reportData.length === 0}
                    className="download-btn"
                >
                    Download CSV
                </button>
            </div>

            {reportData.length > 0 ? (
                <>
                    <table className="report-table">
                        <thead>
                            <tr>
                                <th>Description</th>
                                <th>Current Budget</th>
                                <th>Expended to Date</th>
                                <th>Budget Balance Available</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reportData.map((row, index) =>
                                renderReportRow(row, index)
                            )}
                        </tbody>
                    </table>

                    {/* New section for Indirect Cost Calculations */}
                    <div className="indirect-cost-section">
                        <h3>Indirect Cost Calculations</h3>
                        <table className="indirect-cost-table">
                            <tbody>
                                <tr>
                                    <td className="label-cell">
                                        Indirect Base
                                    </td>
                                    <td className="value-cell">
                                        $
                                        {indirectCostData.indirectBase.toFixed(
                                            2
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="label-cell">
                                        Indirect Federal Share
                                    </td>
                                    <td className="value-cell">
                                        $
                                        {indirectCostData.indirectFederalShare.toFixed(
                                            2
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="label-cell">
                                        Indirect Rate
                                    </td>
                                    <td className="value-cell">
                                        {indirectCostData.indirectRate.toFixed(
                                            2
                                        )}
                                        %
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    
                    {/* Only show the Personnel Time Allocation Calculator when a grant is selected */}
                    <PersonnelTimeAllocationCalculator grantNumber={selectedGrant} />
                </>
            ) : (
                selectedGrant && <p>Loading report data...</p>
            )}

            {/* Don't render the calculator here - it's now conditional inside the reportData block */}
        </div>
    );
};

export default GrantReport;
